<template>
  <footer class = 'con'>
    <div class = 'terms' v-if = 'pcFlag == "PC" && termsFlag'>
      <div class = 'terms_mask'  @click.stop = 'changeTermsFlag'></div>
      <div class = 'terms_con'>
        <div class = 'terms_close' @click.stop = 'changeTermsFlag'></div>
        <div class = 'terms_con_content'>
          <div class = 'title'>网站使用说明</div>
          <div class = 'terms_list'>
            <template v-for = 'item in termsList'>
              <div class = 'terms_title'>{{item.title}}</div>
              <div class = 'terms_inc' v-for = 'con in item.content'>{{con}}</div>      
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class = 'footer_con'>
      <div :class = '["footer_product", "flex_between", {"footer_product_en": lang == "EN"}]'>
        <div class = 'left'>
          <ul class = 'left_con' >
            <li v-for = 'item in seriesList'>
              <router-link class = 'os-regular' :to = '{path:"/series/" + item.address}'>{{item["name_" + lang]}}</router-link>
            </li>
          </ul>
        </div>
        <!-- <div class = 'middle'>
          <template v-if = "lang !== 'EN'">
            <div class="company">
              <div>羽心堂有限公司简介</div>
              <div>传承香港三代的康养美护品牌，融汇东西方颐养智慧，采撷自然力量，成为现代都市人的“体质调理专家。羽心堂利用便捷高效的疗养产品，提前干预亚健康体质，预防慢性病及早衰症状。</div>
            </div>
            <div class="company-address">
              <div>公司地址：北京市朝阳区广渠路66号院8号楼1层174室</div>
              <div>联系方式：010-64756883</div>
            </div>
          </template>
          <template v-else>
            <div class="company">
              <div>Yusumtong Co., Ltd</div>
              <div>Integrating Chinese and Western culture, and the wisdom of three generations in Hong Kong, YU SUM TONG provides natural solutions to urban citizens that are too busy to take care of their mind and physique wellbeing. Through convenient yet effective products, YU SUM TONG aims to intervene in marginal health conditions, prevent chronic illnesses and early ageing symptoms.</div>
            </div>
            <div class="company-address">
              <div>Address: room 174, 1 / F, building 8, 66 Guangqu Road, Chaoyang District, Beijing</div>
              <div>Tel: 010-64756883</div>
            </div>
          </template>
        </div> -->
        <div class = 'right'>
          <img src = './logo.svg' alt = ''/>
          <div class = 'concat' v-for = 'item in concat' :key = 'item'>{{item}}</div>
          <div class = 'nav_social flex_between'>
            <a class = 'nav_social_item' v-for = '(item,index) in navSocial' :href = "index ? item.src : 'javascript:void(0);'" :target = 'index ? "_blank" : ""' >
              <div class = 'social_img' v-if = '!index'>
                <img :src = 'item.pic' alt = ''/>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class = 'footer_bottom os'>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"><span>京ICP备20025142号</span></a>
      <span>@2022 yusumtong.com / All rights reserved.</span>
      <span v-if = 'pcFlag == "PC"' @click = 'changeTermsFlag'>TERMS & CONDITIONS</span>
      <router-link v-else to = '/terms&condition' target = '_blank'>TERMS & CONDITIONS</router-link>
    </div>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      seriesList: [
        { name_EN: "HOMOLOGY OF FOOD & MEDICINE", name_CN: "药食同源", address: "homology"},
        { name_EN: "PHYSIQUE CONDITIONING", name_CN: "体质管理",address: "physique"},
        { name_EN: "SLEEP WELL REMEDY", name_CN: "深眠好梦",address: "sleep"},
        { name_EN: "HAIR & SCALP VITALITY", name_CN: "首乌养发",address: "vitality"},
        // { name_EN: "ANTIVIRAL PROTECTION", name_CN: "非常防护",address: "antiviral"},
        { name_EN: "SECRET GARDEN", name_CN: "秘密花园",address: "secret"},
        { name_EN: "PREMIUM", name_CN: "PREMIUM",address: "antiviral"},
      ],
      concat: [
        "E-mail：info@yusumtong.com",
        // "OFFICE TELEPHONE: + 0571-87241689", 
        // "WHEATWAVE (HANGZHOU) INTERNATIONAL TRADE CO., LTD"
      ],
      navSocial: [
        {pic: '//cdn.idsbuybuybuy.com/image_20191007175932_55528.jpeg'},
        {src: 'https://weibo.com/p/1006067228690362/home'},
        {src: 'https://instagram.com/yusumtongofficial?igshid=17bzi8mhcp3ri'},
        {src: 'https://www.facebook.com/YU-SUM-TONG-674038333018382/'},
      ],
      termsList:[],//条款与协议
      termsFlag: false,
      pcFlag: this.$store.getters.getStoreFlag //PC  PHONE
    }
  },
  computed: {
    lang () {
      return this.$store.getters.getStoreLang;
    }
  },
  mounted(){
    this.getTermsList();
  },
  methods: {
    getTermsList(){
      this.$.get("../../static/json/terms_condition.json").then((res) => {
        this.termsList = res.data;
      })
    },
    // 关闭条款
    changeTermsFlag(){
      this.termsFlag = !this.termsFlag;
    },
    // toregisterSystemInfo(){
    //   window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001")
    // }
  }
}
</script>
<style lang = 'scss' scoped>
  footer{
    background: #000;
    font-size: 12px; 
    color: #fff;
    padding-top: 5.5%;
    color: #999;
    .terms{
      position: fixed;
      z-index: 99999;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      .terms_mask{
        background: rgba(0,0,0,.6);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
      .terms_con{
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 60%;
        height: 80%;
        margin:auto;
        background: #fff;
        color: #000;
        padding: 60px 20px 40px 40px;
        .terms_close{
          position: absolute;
          top: 20px;
          right: 20px;
          width: 20px;
          height: 20px;
          opacity: 0.2;
          background:url('//cdn.idsbuybuybuy.com/image_20191015113024_96039.png') no-repeat center;
          background-size: cover;
          &:hover{
            cursor: pointer;
          }
        }
        .terms_con_content{
          overflow-y: scroll;
          padding-right: 40px;
          height: 100%;
          .title{
            font-size: 44px;
          }
          .terms_list{
            line-height: 1.5;
            margin-top: 40px;
            .terms_title{
              font-size: 18px;
              line-height: 3;
            }
            .terms_inc{
              font-size: 12px;
            }
          }
          &::-webkit-scrollbar-thumb{
            background: #f5f5f5;
          }
          
        }
      }
    }
    .footer_con{
      width: 74.7%;
      margin: 0 auto;
      .footer_product{
        .left{
          ul{
            li{
              line-height: 19px;
              margin-top: 14px;
              cursor: pointer;
              &:first-child{
                margin-top: 0;
              }
              &:hover{
                color: #fff;
              }
            }
          }
        }
        .middle{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 40%;
          line-height: 1.5;
          .company-address{
            margin-top: 20px;
          }
        }
        .right{
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-between;
          .concat{
            margin-top: 60px;
          }
          .nav_social{
            margin-top: 35px;
            width: 172px;
            align-items: center;
            .nav_social_item{
              position: relative;
             width: 40px;
              height: 40px;
              background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_53470.png');
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
              cursor: pointer;
              &:nth-of-type(1):hover{
                background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_80665.png");
              }
              &:nth-of-type(2){
                background-image: url('//cdn.idsbuybuybuy.com/image_20191008181153_61001.png');
                &:hover{
                  background-image: url("//cdn.idsbuybuybuy.com/image_20191008181153_21875.png");
                }
              }
              &:nth-of-type(3){
                background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_69577.png');
                &:hover{
                  background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_40014.png");
                }
              }
              &:nth-of-type(4){
                background-image: url('//cdn.idsbuybuybuy.com/image_20191008181152_90538.png');
                &:hover{
                  background-image: url("//cdn.idsbuybuybuy.com/image_20191008181152_77390.png");
                }
              }
              .social_img{
                display:none;
                position: absolute;
                top: -130px;
                left: 50%;
                transform: translateX(-50%);
                width: 120px;
                height: 120px;
                background-color: #ffffff;
                border-radius: 10px;
                img{
                  width: 100px;
                  height: 100px;
                  object-fit: cover;
                  margin: 10px auto;
                }
              }
              &:hover{
                .social_img{
                  display: block;
                }
              }
            }
          }
        }
      }
    }
    .footer_bottom{
      border-top: 1px solid #f9f9f9;
      text-align: center;
      margin-top: 5.6%;
      line-height: 2;
      display: flex;
      justify-content: center;
      flex-direction: column;
      cursor: default;
      span:nth-of-type(3){
        cursor: pointer;
        opacity: 0.5;
        &:hover{
          opacity: 1;
        }
      }
    }
  }
  .webapp footer{
    font-size: 0.24rem; 
    padding-top: 0.5rem;
    .footer_con{
      width: 100%;
      padding: 0 0.3rem;
      box-sizing: border-box;
      .footer_product{
        position: relative;
        padding-bottom: 1rem;
        display: block;
        &.footer_product_en{
          padding-bottom: 2rem;
        }
        .left{
          ul{
            li{
              line-height: 0.19rem;
              margin-top: 0.2rem;
              &:first-child{
                margin-top: 0;
              }
            }
          }
        }
        .middle{
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          .company-address{
            margin-top: 0.4rem;
          }
        }
        .right{
          margin-top: 2rem;
          .nav_social{
            display: none;
          }
        }
      }
    }
    .footer_bottom{
      margin-top: 0.5rem;
      line-height: 0.4rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      padding-bottom: 0.5rem;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/common/footer.vue